// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import ModalContainerController from "./modal_container_controller"
application.register("modal-container", ModalContainerController)

import TabListController from "./tab_list_controller"
application.register("tab-list", TabListController)
